export default __webpack_public_path__ + "static/media/appleStore.1634fa08.svg";